import { Button as MButton, buttonClasses } from '@mui/material'
import { styled } from '@mui/material/styles'

export const AppButton = styled(MButton)(({ theme }) => ({
  borderRadius: 6,
  textTransform: 'initial',
  [`&.${buttonClasses.outlined}`]: {
    backgroundColor: 'transparent',
    color: theme.custom.colors.common.black,
    border: `2px solid ${theme.custom.colors.common.black}`,
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.custom.colors.common.black,
    },
    '&:disabled': {
      backgroundColor: 'transparent',
      color: theme.custom.colors.common.grey1,
    },
  },
  [`&.${buttonClasses.contained}`]: {
    backgroundColor: theme.custom.colors.common.black,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.custom.colors.common.black,
      color: 'white',
    },
    '&:disabled, &.Mui-disabled': {
      backgroundColor: theme.custom.colors.common.grey1,
      color: 'white',
    },
  },
})) as typeof MButton

export const BaseRedButton = styled(AppButton)(({ theme }) => ({
  borderColor: theme.custom.colors.common.red,
  color: theme.custom.colors.common.red,
  height: '42px',

  [`&.${buttonClasses.outlined}`]: {
    borderColor: theme.custom.colors.common.red,
    color: theme.custom.colors.common.red,
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.custom.colors.common.red,
    },
    '&:disabled': {
      color: theme.custom.colors.common.grey1,
    },
  },

  [`&.${buttonClasses.contained}`]: {
    backgroundColor: theme.custom.colors.common.red,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.custom.colors.common.red,
      color: 'white',
    },
    [`&:disabled, &.${buttonClasses.disabled}`]: {
      backgroundColor: theme.custom.colors.common.grey1,
      color: 'white',
    },
  },

  [theme.breakpoints.down('sm')]: {
    height: '60px',
  },
}))
